import React, { useEffect, useState } from 'react';
import ButtonStartIcon from '../../../../../button/ButtonStartIcon';
import Typography from '@mui/material/Typography';
import InputField from '../../../../../FormControl/input/InputField';
import Dialog from '../../../../../dialog/Dialog';
import useLevels from '../../../../../../hooks/curriculum/useLevels';
import { Alert } from '@mui/material';
import useFetchData from '../../../../../../hooks/useFetchData';

const LevelDialog = ({ show, onClose, type, data = {} }) => {
  const { errors: errorsData, createLevel, updateLevel, deleteLevel } = useLevels();
  const [form, setInputForm] = useState({});
  const [errors, setInputErrors] = useState(errorsData);
  const [loading, toggleLoading] = useState(false);
  const { isLoading: isLoadingMaxPosition, data: dataMaxPosition } = useFetchData(
    'setting/level/max-position'
  );

  const onChange = (e) => {
    const { name, value } = e.target;
    setInputForm({ ...form, [name]: value });
    setInputErrors({ ...errors, [name]: null });
  };

  const onSave = async (e) => {
    if (!['create', 'edit', 'delete'].includes(type)) {
      setInputErrors({ message: 'Invalid type' });
      return;
    }
    e.preventDefault();
    toggleLoading(true);
    try {
      let result = { error: false };
      form.position = String(form.position);
      if (type === 'create') {
        result = await createLevel(form);
      }
      if (type === 'edit') {
        result = await updateLevel(form._id, form);
      }
      if (type === 'delete') {
        result = await deleteLevel(form._id);
      }
      if (result.error) {
        setInputErrors(result);
      } else {
        onClose();
      }
    } finally {
      toggleLoading(false);
    }
  };

  useEffect(() => {
    setInputErrors(errorsData);
  }, [errorsData]);

  useEffect(() => {
    setInputForm(data || {});
  }, [data]);

  useEffect(() => {
    if (isLoadingMaxPosition) return;
    if (type === 'create' && dataMaxPosition) {
      setInputForm((old) => ({ ...old, position: dataMaxPosition }));
    }
  }, [isLoadingMaxPosition]);

  const Actions = (
    <>
      <ButtonStartIcon
        onClick={onClose}
        color='primary'
        variant='outlined'
        disabled={loading}
        startIcon={['fal', 'times']}
      >
        Cancel
      </ButtonStartIcon>
      {['create', 'edit', 'delete'].includes(type) && (
        <ButtonStartIcon
          onClick={onSave}
          color='primary'
          variant='contained'
          disabled={loading}
          loading={loading}
          startIcon={['fal', 'check']}
        >
          {type === 'delete' ? 'Confirm' : 'Save'}
        </ButtonStartIcon>
      )}
    </>
  );

  return (
    <Dialog id={`${type}-level`} show={show} title={`${type} level`} onClose={onClose} actions={Actions}>
      {type === 'delete' ? (
        <Typography>
          Are you sure you want to delete the level: <b>{form.name}</b>?
        </Typography>
      ) : (
        <div className='flex flex-col gap-4 py-4'>
          <div className='grid grid-cols-3 items-center gap-4'>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Position
            </Typography>
            <div className='col-span-2'>
              {type === 'preview' ? (
                <Typography>{form.position}</Typography>
              ) : (
                <InputField
                  id='position'
                  name='position'
                  value={form.position}
                  error={errors?.position}
                  helperText={errors?.position}
                  onChange={onChange}
                  type='number'
                  fullWidth
                />
              )}
            </div>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Code
            </Typography>
            <div className='col-span-2'>
              {type === 'preview' ? (
                <Typography>{form.code}</Typography>
              ) : (
                <InputField
                  id='code'
                  name='code'
                  value={form.code}
                  error={errors?.code}
                  helperText={errors?.code}
                  onChange={onChange}
                  fullWidth
                />
              )}
            </div>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Name
            </Typography>
            <div className='col-span-2'>
              {type === 'preview' ? (
                <Typography>{form.name}</Typography>
              ) : (
                <InputField
                  id='name'
                  name='name'
                  value={form.name}
                  error={errors?.name}
                  helperText={errors?.name}
                  onChange={onChange}
                  fullWidth
                />
              )}
            </div>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Short Name
            </Typography>
            <div className='col-span-2'>
              {type === 'preview' ? (
                <Typography>{form.shortName}</Typography>
              ) : (
                <InputField
                  id='shortName'
                  name='shortName'
                  value={form.shortName}
                  error={errors?.shortName}
                  helperText={errors?.shortName}
                  onChange={onChange}
                  fullWidth
                />
              )}
            </div>
          </div>
        </div>
      )}
      {errors && errors.message && (
        <Alert severity='error' onClose={() => setInputErrors({ message: null })}>
          {errors.message}
        </Alert>
      )}
    </Dialog>
  );
};

export default LevelDialog;
